import { z } from "zod";
import { TranslationSchema } from "@/utils/i18n";

export namespace InstagramSearch {
  export const OptionSchema = z.object({
    id: z.number(),
    name: z.string(),
  });

  export type Option = z.infer<typeof OptionSchema>;

  export const RangeSchema = z.object({
    min: z.number(),
    max: z.number(),
  });

  export type RangeValue = {
    start: number;
    end: number;
  };

  export const ConfigSchema = z.object({
    api: z.object({
      getCategories: z.string(),
      getCountries: z.string(),
      getRegions: z.string(),
      getCities: z.string(),
      getInfluencers: z.string(),
      getProfiles: z.string(),
      getLists: z.string(),
      getList: z.string(),
      createList: z.string(),
      editList: z.string(),
      deleteList: z.string(),
      addToList: z.string(),
      removeFromList: z.string(),
      exportCsv: z.string(),
      exportXls: z.string(),
    }),

    links: z.object({
      instagramViewer: z.string(),
      instagramDownloader: z.string(),
      profileAnalyzer: z.string(),
      instagramSearchSubscribe: z.string(),
    }),

    router: z.object({
      basename: z.string(),
      influencers: z.string(),
      profiles: z.string(),
      lists: z.string(),
      list: z.string(),
    }),

    isAuthorized: z.boolean(),
    isSubscribed: z.boolean(),

    genders: OptionSchema.array(),

    followers: RangeSchema,

    posts: RangeSchema,

    influencersCategories: OptionSchema.array(),

    sorting: OptionSchema.array(),

    translation: TranslationSchema,
  });

  export type Config = z.infer<typeof ConfigSchema>;

  export const ProfileSchema = z.object({
    id: z.union([z.string(), z.number()]),
    image: z.string(),
    username: z.string(),
    name: z.string(),
    posts: z.number(),
    followers: z.number(),
    phone: z.string().optional(),
    email: z.string().optional(),
    website: z.string().optional(),
    text: z.string(),
    limit: z
      .object({
        type: z.literal(["sign-up", "subscribe"]),
        count: z.number(),
        total: z.number(),
        href: z.string(),
      })
      .optional(),
  });

  export type Profile = z.infer<typeof ProfileSchema>;

  export const ListSchema = z.object({
    id: z.number(),
    name: z.string(),
    profiles: ProfileSchema.shape.id.array().transform((arr) => new Set(arr)),
    images: z.string().array(),
  });

  export type List = z.infer<typeof ListSchema>;
}
